import React from 'react';
import { AssistanceFormContext, AssistanceFormContextData } from './AssistanceForm.provider';

export const useAssistanceFormContext = (): AssistanceFormContextData => {
  const cookieContext = React.useContext(AssistanceFormContext);

  if (!cookieContext) {
    throw new Error('useAssistanceFormContext must be used within a AssistanceFormProvider');
  }

  return cookieContext;
};
